import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
    getSinglePanel,
    reset,
} from "../../Redux/PanlesSlice/SinglePanelSlice";
import { useFormik } from "formik";
import { FormHeading } from "../../Layouts/Heading";
import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import * as yup from "yup";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import styled from "styled-components";
import {
    reset as resetPanel,
    updatePanel,
} from "../../Redux/PanlesSlice/PanelsSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";

///////////////////////////////////////////

const validationSchema = yup.object({
    title: yup
        .string("Enter your title")
        .min(2, "Minimum number of letters 2")
        .required("title is required"),
    wattage: yup.number("Enter your wattage").required("wattage is required"),
});

const EditPanel = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const [formSubmit, setFormSubmit] = useState(false);

    useEffect(() => {
        const getPanel = async () => {
            await dispatch(getSinglePanel(id));
            await dispatch(reset());
        };

        getPanel();
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();

        if (isError) {
            toast.error(massage);
        }
        dispatch(reset());
    }, [dispatch, id]);

    const { panel, isError, isSuccess, isLodaing, massage } = useSelector(
        (state) => state.panel
    );

    const loadingPanels = useSelector((state) => state.panels.isLodaing);
    const successPanels = useSelector((state) => state.panels.isSuccess);
    const massagePanels = useSelector((state) => state.panels.massage);
    const errorPanels = useSelector((state) => state.panels.isError);

    const SinglePanel = panel ? panel?.data : "";

    const { states, isStatesloading } = useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;

    const formik = useFormik({
        initialValues: {
            title: panel?.data?.title,
            price: panel?.data?.price,
            wattage: "",
            description: SinglePanel.description,
            state_id: "",
            image_path: "",
            is_default: "",
            dimension: '',
            weight: '',
            frame_color: '',
            sheet_color: '',
            cell_type: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setFormSubmit(true);
            const formData = new FormData();
            formData.append("_method", "PUT");
            formData.append("title", values.title);
            formData.append("price", values.price);
            formData.append("panel_id", id);
            formData.append("wattage", values.wattage);
            formData.append("description", values.description);
            formData.append("price", values.price);
            formData.append("state_id", values.state_id);
            formData.append("image_path", values.image_path);
            formData.append("is_default", values.is_default);
            formData.append("dimension", values.dimension);
            formData.append("weight", values.weight);
            formData.append("frame_color", values.frame_color);
            formData.append("sheet_color", values.sheet_color);
            formData.append("cell_type", values.cell_type);

            await dispatch(updatePanel(formData));
            await dispatch(resetPanel());
        },
    });

    useEffect(() => {
        formik.values.title = panel?.data?.title;
        formik.values.price = panel?.data?.price;
        formik.values.wattage = panel?.data?.wattage;
        formik.values.description = panel?.data?.description;
        formik.values.price = panel?.data?.price ? panel?.data?.price : 0;
        formik.values.state_id = panel?.data?.state_id;
        formik.values.dimension = panel?.data?.dimension;
        formik.values.weight = panel?.data?.weight;
        formik.values.frame_color = panel?.data?.frame_color;
        formik.values.sheet_color = panel?.data?.sheet_color;
        formik.values.cell_type = panel?.data?.cell_type;
        formik.values.is_default = Boolean(panel?.data?.is_default);
    }, [SinglePanel]);

    useEffect(() => {
        if (errorPanels) {
            toast.error(massagePanels);
        }
        if (successPanels && formSubmit) {
            setFormSubmit(false)
            toast.success("panel updated succesfully");
        }
    }, [errorPanels, massagePanels, successPanels]);

    return (
        <>
            <FormContainer>
                <FormHeading>Edit Panel </FormHeading>
                {isLodaing && <LoadingAnimation />}
                {!isLodaing && !isSuccess && (
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="title"
                                    name="title"
                                    label="Title"
                                    value={formik.values.title || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.title &&
                                        Boolean(formik.errors.title)
                                    }
                                    helperText={
                                        formik.touched.title &&
                                        formik.errors.title
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="price"
                                    name="price"
                                    label="Price"
                                    value={formik.values.price || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.price &&
                                        Boolean(formik.errors.price)
                                    }
                                    helperText={
                                        formik.touched.price &&
                                        formik.errors.price
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="wattage"
                                    name="wattage"
                                    type="number"
                                    label="wattage"
                                    value={formik.values.wattage || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.wattage &&
                                        Boolean(formik.errors.wattage)
                                    }
                                    helperText={
                                        formik.touched.wattage &&
                                        formik.errors.wattage
                                    }
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="weight"
                                    name="weight"
                                    type="number"
                                    label="weight"
                                    value={formik.values.weight || ""}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.weight &&
                                        Boolean(formik.errors.weight)
                                    }
                                    helperText={
                                        formik.touched.weight &&
                                        formik.errors.weight
                                    }
                                />
                            </Grid>
                            {/* <Grid item mb={1} xs={12} md={6}>
                <TextField
                  fullWidth
                  id="description"
                  name="description"
                  label="description"
                  value={formik.values.description || ""}
                  onChange={formik.handleChange}
                />
              </Grid>
              <Grid item mb={1} xs={12} md={6}>
                <TextField
                  fullWidth
                  id="price"
                  name="price"
                  label="price"
                  value={formik.values.price}
                  onChange={formik.handleChange}
                />
              </Grid> */}
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        required={true}
                                        value={formik.values.state_id || ""}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                    Dimension
                                    </InputLabel>
                                    <Select
                                        id="dimension"
                                        name="dimension"
                                        label="Dimension"
                                        required={true}
                                        value={formik.values.dimension}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="length"
                                        >length
                                        </MenuItem>
                                        <MenuItem
                                        value="width"
                                        >width
                                        </MenuItem>
                                        <MenuItem
                                        value="height"
                                        >height
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                    Frame Color
                                    </InputLabel>
                                    <Select
                                        id="frame_color"
                                        name="frame_color"
                                        label="Frame Color"
                                        required={true}
                                        value={formik.values.frame_color}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="blue"
                                        >blue
                                        </MenuItem>
                                        <MenuItem
                                        value="silver"
                                        >silver
                                        </MenuItem>
                                        <MenuItem
                                        value="black"
                                        >black
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Sheet Color
                                    </InputLabel>
                                    <Select
                                        id="sheet_color"
                                        name="sheet_color"
                                        label="Sheet Color"
                                        required={true}
                                        value={formik.values.sheet_color}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="blue"
                                        >blue
                                        </MenuItem>
                                        <MenuItem
                                        value="silver"
                                        >silver
                                        </MenuItem>
                                        <MenuItem
                                        value="black"
                                        >black
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        Cell Type
                                    </InputLabel>
                                    <Select
                                        id="cell_type"
                                        name="cell_type"
                                        label="Cell Type"
                                        required={true}
                                        value={formik.values.cell_type}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="monocrystalline"
                                        >monocrystalline
                                        </MenuItem>
                                        <MenuItem
                                        value="polycrystalline"
                                        >polycrystalline
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <InputLabel> Defalut ? </InputLabel>
                                <Switch
                                    id="is_default"
                                    name="is_default"
                                    checked={formik.values.is_default}
                                    onChange={formik.handleChange}
                                    inputProps={{ "aria-label": "controlled" }}
                                />
                            </Grid>
                        </Grid>
                        <PrimaryButton fullWidth type="submit">
                            {loadingPanels ? "loading..." : "Edit"}
                        </PrimaryButton>
                    </form>
                )}
            </FormContainer>
        </>
    );
};

const FormContainer = styled.div`
    padding: 4rem;
    margin: 1rem auto;
    background: var(--white);
    box-shadow: 0 5px 8px 0 var(--box-shadow);
    border-radius: 1rem;
    width: 70%;
`;

export default EditPanel;
